import React from 'react';
import styles from './FrameFooter.module.scss';

export default function FrameFooter({ children }) {
  return <footer className={styles.frameFooter}>{children}</footer>;
}
